import PrivateRouter from "./PrivateRouter";

export default PrivateRouter;
